export var calculateNextOffsetToLeft = function calculateNextOffsetToLeft(offset, outerWidth, innerWidth) {
  // When scroll is not allowed
  if (outerWidth >= innerWidth) {
    return 0;
  }

  // When scroll to left is not possible
  if (offset <= 0) {
    return 0;
  }

  return Math.max(offset - outerWidth, 0);
};

export var calculateNextOffsetToRight = function calculateNextOffsetToRight(offset, outerWidth, innerWidth) {
  // When scroll is not allowed
  if (outerWidth >= innerWidth) {
    return 0;
  }

  // When scroll to right is not possible
  if (offset + outerWidth >= innerWidth) {
    return innerWidth - outerWidth;
  }

  return Math.min(offset + outerWidth, innerWidth - outerWidth);
};

export var closestToOffset = function closestToOffset(offset) {
  return function (threshold, index, thresholds) {
    return offset >= threshold && offset < (index + 1 >= thresholds.length ? Infinity : thresholds[index + 1]);
  };
};

export var snapToThreshold = function snapToThreshold(offset, thresholds) {
  return thresholds.find(closestToOffset(offset)) || thresholds[0] || 0;
};

export var shiftThresholdToLeft = function shiftThresholdToLeft(threshold, innerWidth, outerWidth, thresholds) {
  var currentIndex = thresholds.indexOf(threshold);
  if (currentIndex === -1) return threshold;
  var prevThreshold = thresholds[currentIndex - 1] || thresholds[0];
  var nextThreshold = thresholds[currentIndex + 1] || innerWidth;
  var width = nextThreshold - prevThreshold;
  return width <= outerWidth ? prevThreshold : threshold;
};

export var shiftThresholdToRight = function shiftThresholdToRight(threshold, innerWidth, outerWidth, thresholds) {
  var currentIndex = thresholds.indexOf(threshold);
  if (currentIndex === -1) return threshold;
  var nextThreshold = thresholds[currentIndex + 1] || thresholds[thresholds.length - 1];
  var nextNextThreshold = thresholds[currentIndex + 2] || innerWidth;
  var width = nextNextThreshold - threshold;
  return width <= outerWidth ? nextThreshold : threshold;
};